import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { generateConfig } from "../../utils/api";
import { handleApiError } from "../../utils/apiErrorHandler";

// Fetch current system version
export const fetchSystemVersion = createAsyncThunk(
  "version/fetchSystemVersion",
  async (_, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log('[Version Thunk] Fetching system version from API');
      
      const state = getState();
      const token = state.auth.token;
      const { baseURL } = generateConfig({ token });

      // Version API is public, no authentication required
      const response = await axios.get(`${baseURL}/api/version`);
      
      console.log('[Version Thunk] Version fetched successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('[Version Thunk] Error fetching version:', error);
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);